import { InsuranceService } from 'src/app/core/services/insurance.service';
import { Component, EventEmitter, Output } from '@angular/core';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';

@Component({
  selector: 'aig-modal-client',
  imports: [ModalComponent],
  templateUrl: './modal-client.component.html',
  styleUrl: './modal-client.component.scss',
})
export class ModalClientComponent {
  @Output() titularAnswered = new EventEmitter<boolean>();

  constructor(private insuranceService: InsuranceService) {}

  clickHide(): void {
    this.titularAnswered.emit(false);
  }

  public OpenNewClaim(): void {
   this.titularAnswered.emit(true);
  }
}
